<template>
  <PromptBar>
    <template #icon>
      <FriedIcon icon="info-circle" />
    </template>
    <template #title>{{ $t('preparing-download') }}</template>
    <template #description>
      {{ $t('document-will-be-downloaded-shortly') }}
    </template>
  </PromptBar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PromptBar from '@getaccept/lib-shared/src/prompt-bar/PromptBar.vue';

export default defineComponent({
  components: {
    PromptBar,
  },
});
</script>
